'use strict';

module.exports = require('./Trigger');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.1.8.3@rc-trigger/lib/index.js
 ** module id = 38
 ** module chunks = 0 1
 **/